<app-aggregated-amount-item
  name="ダウンロード数"
  icon="./assets/universal_music.png"
  amount="{{ (downloadUnitSummary$ | async)?.units }}"
  unit="アルバム換算数"
  link=""
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のダウンロード数です。ダウンロード数は選択期間内の合計数です。"
  [rate]="(downloadUnitSummary$ | async)?.rate"
  [hasAmount]="(downloadUnitSummary$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
